import { render, staticRenderFns } from "./bheight.vue?vue&type=template&id=bf51f89c&scoped=true"
import script from "./bheight.vue?vue&type=script&lang=js"
export * from "./bheight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf51f89c",
  null
  
)

export default component.exports